export const formatResponseTime = (responseTime) => {
  if (!responseTime) {
    return null;
  }
  const hours = Math.round(responseTime / 60);

  if (hours < 1) {
    return '1h';
  }
  if (hours <= 12) {
    return `${hours}h`;
  }
  if (hours <= 24) {
    return '24h';
  }

  return '48h';
};
